import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetContentCollectionStyle0 = gravityIconIndividualCss;

const GravityIconAssetContentCollection = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '0e13f726e4ec137bdb1433bd7efb7d402c4e68bf', color: this.color, size: this.size }, h("svg", { key: '6c312a71c22ea9d4e0dcea8c05c8f760c61268ee', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'd6b477f1a6d34bcf2d215617ffdf3a8f62c14737', d: "M3.625 3.75c0-.069.056-.125.125-.125h6c.069 0 .125.056.125.125v6a.125.125 0 0 1-.125.125h-6a.125.125 0 0 1-.125-.125v-6Zm8.5 0c0-.069.056-.125.125-.125h6c.069 0 .125.056.125.125v6a.125.125 0 0 1-.125.125h-6a.125.125 0 0 1-.125-.125v-6Zm0 8.504c0-.069.056-.125.125-.125h6c.069 0 .125.056.125.125v6a.125.125 0 0 1-.125.125h-6a.125.125 0 0 1-.125-.125v-6Zm-8.501 0c0-.069.056-.125.125-.125h6c.069 0 .125.056.125.125v6a.125.125 0 0 1-.125.125h-6a.125.125 0 0 1-.125-.125v-6Z", stroke: "currentColor", "stroke-width": ".75" }))));
    }
};
GravityIconAssetContentCollection.style = GravityIconAssetContentCollectionStyle0;

export { GravityIconAssetContentCollection as gravity_icon_asset_content_collection };

//# sourceMappingURL=gravity-icon-asset-content-collection.entry.js.map